import axios from 'axios';
import { toast } from 'react-toastify';
import { AppDispatch } from '../store';
import http from '../services/httpService';
import { getDetailedErrorMessage } from '../../utilities/errorHandler';

export const signUp =
  (transformedData: any) => async (dispatch: AppDispatch) => {
    dispatch({ type: 'SIGNUP_REQUEST' });

    try {
      const response = await http.post('/register', transformedData);

      if (response.status === 201) {
        dispatch({
          type: 'SIGNUP_SUCCESS',
        });

        toast.success('Registration successful! Redirecting to login.', {
          autoClose: 3000,
          pauseOnHover: false,
          onClose: () => {
            dispatch({ type: 'SIGNUP_LOADING_FINISHED' });
            window.location.reload();
          },
        });
      }
    } catch (error) {
      const errorMessage = getDetailedErrorMessage(error, 'Registration failed. Please check your information and try again.');
      
      dispatch({
        type: 'SIGNUP_FAILURE',
        payload: errorMessage,
      });
      
      console.error('Registration error details:', error);
      toast.error(errorMessage);
    }
  };
